import React from 'react';
import { Loader2 } from 'lucide-react';
import { useRowHighlight } from '@/components/ui/RowHighlight';

export const LeadExecutionTable = ({ columns, data, isLoading, emptyMessage = "No records found" }) => {
  const { getHighlightClass } = useRowHighlight(data, '_id');
  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm mt-2">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200">
              {columns.map((col, idx) => (
                <th key={idx} className="px-5 py-3 text-left text-[11px] font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {isLoading ? (
              <tr>
                <td colSpan={columns.length} className="p-8 text-center text-slate-500">
                  <Loader2 className="w-5 h-5 animate-spin mx-auto mb-2" />
                  Loading...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="p-8 text-center text-[#65768e] text-sm font-semibold">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              data.map((row, rowIdx) => (
                <tr key={rowIdx} id={`row-${row._id}`} className={`hover:bg-slate-50 transition-colors ${getHighlightClass(row)}`}>
                  {columns.map((col, colIdx) => (
                    <td key={colIdx} className="px-5 py-3 align-middle whitespace-nowrap">
                      {col.render(row)}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
